import { QObjDBFieldDef } from "../CoreApp/QObjDBFieldDef";

export function AddFieldDef(theClass, fieldID, fieldName, fieldLabel, setReadOnly) {
  var fieldDef = new QObjDBFieldDef();
  fieldDef.InitField(fieldID, fieldName, theClass);
  if (setReadOnly) fieldDef.SetReadOnly(true);
  fieldDef.SetFieldLabel(fieldLabel);
  theClass.AddField(fieldDef);

  return fieldDef;
}
